<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'

import { rules } from '@/helpers/rules'
import { useEditorStore } from '@/stores/Editor'
import { useAccountStore } from '@/stores/Account'
import { usePublicData } from '@/stores/PublicData'
import { PLAN_TYPES } from '@/api/interfaces'

import FormGroup from '@/components/common/FormGroup.vue'
import UpgradePlanButton from '@/components/editor/UpgradePlanButton.vue'

const editorStore = useEditorStore()
const publicStore = usePublicData()
const accountStore = useAccountStore()
const { t } = useTranslate('local')
</script>

<template>
  <FormGroup
    :label="t('EditorHeroSettings.content.fields.pageTitle.label')"
    label-for="page-title"
    :disabled="accountStore.hasStarterPlan"
  >
    <v-text-field
      v-model="editorStore.editor.hero.content[publicStore.lang].title"
      id="page-title"
      variant="outlined"
      flat
      :rules="[rules.maxlength()]"
      :disabled="accountStore.hasStarterPlan || editorStore.publishLoading"
      :placeholder="t('EditorHeroSettings.content.fields.pageTitle.placeholder')"
    />
  </FormGroup>
  <UpgradePlanButton v-if="accountStore.hasStarterPlan" :plan="PLAN_TYPES.GROWTH" />
  <FormGroup
    :label="t('EditorHeroSettings.content.fields.pageDescription.label')"
    label-for="page-description"
  >
    <v-text-field
      v-model="editorStore.editor.hero.content[publicStore.lang].subtitle"
      id="page-description"
      variant="outlined"
      flat
      :rules="[rules.maxlength()]"
      :disabled="editorStore.publishLoading"
      :placeholder="t('EditorHeroSettings.content.fields.pageDescription.placeholder')"
    />
  </FormGroup>
  <v-checkbox
    v-if="publicStore.lang === 'en'"
    v-model="editorStore.editor.hero.memberSince.visible"
    :disabled="editorStore.publishLoading"
    :label="t('EditorHeroSettings.content.fields.memberSince.label')"
  />
</template>

<style lang="scss" scoped></style>
